module.exports = __webpack_public_path__ + "img/uc-logo-white.37c7b1a8.svg";